import React from 'react';
import { HorizontalMenuItem } from 'types/model';
import { MenuClassName, ShadowBackgroundClassName } from './style';
import { Layout } from 'fronton-react';
import { MenuItem } from './menu-item';
import { useHorizontalMenuAnalyticsEvent } from '../../hooks/analytics/use-horizontal-menu-analytics-event';

export const DATA_QA_LAYOUT = 'header_fixed_horizontal_menu';
export const DATA_QA_SCROLLABLE_CONTAINER = 'horizontal_menu_scrollbale_container';

type HorizontalMenuProps = {
  list: HorizontalMenuItem[];
};

export const HorizontalMenu = (props: HorizontalMenuProps) => {
  const { handleItemClick, handleTouchMove } = useHorizontalMenuAnalyticsEvent();

  return (
    <>
      <Layout data-qa={DATA_QA_LAYOUT}>
        <div className={MenuClassName} onTouchMove={handleTouchMove} data-qa={DATA_QA_SCROLLABLE_CONTAINER}>
          {props.list.map((item) => {
            return <MenuItem key={item.text} model={item} onClick={handleItemClick} />;
          })}
        </div>
      </Layout>
      <div className={ShadowBackgroundClassName} />
    </>
  );
};
